import React from 'react';
import { useTranslation } from 'react-i18next';
import { CommonDialog } from 'src/components/shared/dialog/CommonDialog';

export const DeleteHistorySucceededDialog = () => {
  const { t } = useTranslation(['resort', 'translation']);
  const title = t('translation:dialog_delete_success');
  const description = t('dialog_delete_history_success_desc');
  return <CommonDialog title={title} description={description} />;
};
